import { render, staticRenderFns } from "./ImportTermsOfUse.vue?vue&type=template&id=304c8280&scoped=true&"
import script from "./ImportTermsOfUse.vue?vue&type=script&lang=js&"
export * from "./ImportTermsOfUse.vue?vue&type=script&lang=js&"
import style0 from "./ImportTermsOfUse.vue?vue&type=style&index=0&id=304c8280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304c8280",
  null
  
)

export default component.exports